"use strict";

import angular from "angular";

import template from "./help-item.component.html";
import "./themes/help-item-dark.component.scss";
import "./themes/help-item.component.scss";

class HelpItemComponent {
    constructor() {
        this.isIconArray = false;
    }

    $onInit() {
        this.isIconArray = Array.isArray(this.help.icon) ? true : false;
    }

    toggleOpened() {
        this.opened = !this.opened;
    }

    $onDestroy() {}
}
HelpItemComponent.$inject = [];

const name = "helpItemComponent";
const def = {
    bindings: {
        help: "<"
    },
    controller: HelpItemComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
